import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';

const SubscriberService = new ModelService(apiRoutes.subscribers, '/subscribers', 'subscribers');

SubscriberService.defaultlogo = `${api.baseUrl}/default-logo.png`;

SubscriberService.getLogo = (filename, w = false, h = false, c = false) => {
  if (!filename) return SubscriberService.defaultlogo;
  return SubscriberService.getFilePathByDir('/uploads/subscribers', filename, w, h, c);
};

SubscriberService.constructor.prototype.start = async (id) => {
  return api.catchError(async () => {
    const url = `/subscribers/${id}/start`;
    const { data } = await api.put(url);
    return data;
  });
};

SubscriberService.constructor.prototype.stop = async (id) => {
  return api.catchError(async () => {
    const url = `/subscribers/${id}/stop`;
    const { data } = await api.put(url);
    return data;
  });
};

SubscriberService.STATUS_ACTIVE = 1;
SubscriberService.STATUS_INACTIVE = 0;
SubscriberService.STATUS_PENDING = 3;

SubscriberService.getStatusList = t => ({
  [SubscriberService.STATUS_ACTIVE]: t('Active'),
  [SubscriberService.STATUS_INACTIVE]: t('Inactive'),
  [SubscriberService.STATUS_PENDING]: t('Pending'),
});

SubscriberService.getStatusOptions = t => SubscriberService
  .prepareOptionsFromSimpleObject(SubscriberService.getStatusList(t));

SubscriberService.getStatusTitle = (status, t) => {
  const label = SubscriberService.getStatusList(t)[status];
  return label || '-';
};

SubscriberService.getColorByStatus = (status) => {
  switch (status) {
    case SubscriberService.STATUS_ACTIVE:
      return 'success';
    case SubscriberService.STATUS_INACTIVE:
      return 'danger';
    default:
      return 'secondary';
  }
};

SubscriberService.PAYMENT_STATUS_PAID = 1;
SubscriberService.PAYMENT_STATUS_NOT_PAID = 0;
SubscriberService.PAYMENT_STATUS_PENDING = 2;
SubscriberService.PAYMENT_STATUS_TRAIL = 3;
SubscriberService.PAYMENT_STATUS_CANCEL = 4;

SubscriberService.getPaymentStatusList = t => ({
  [SubscriberService.PAYMENT_STATUS_PAID]: t('Paid'),
  [SubscriberService.PAYMENT_STATUS_NOT_PAID]: t('Not paid'),
  [SubscriberService.PAYMENT_STATUS_PENDING]: t('Pending'),
  [SubscriberService.PAYMENT_STATUS_TRAIL]: t('Trial'),
  [SubscriberService.PAYMENT_STATUS_CANCEL]: t('Cancelled'),
});

SubscriberService.getPaymentStatusOptions = t => SubscriberService
  .prepareOptionsFromSimpleObject(SubscriberService.getPaymentStatusList(t));

SubscriberService.getPaymentStatusTitle = (status, t) => {
  const label = SubscriberService.getPaymentStatusList(t)[status];
  return label || '-';
};

SubscriberService.getColorByPaymentStatus = (status) => {
  switch (status) {
    case SubscriberService.PAYMENT_STATUS_PAID:
      return 'success';
    case SubscriberService.PAYMENT_STATUS_TRAIL:
      return 'success';
    case SubscriberService.PAYMENT_STATUS_NOT_PAID:
      return 'danger';
    case SubscriberService.PAYMENT_STATUS_PENDING:
      return 'warning';
    case SubscriberService.PAYMENT_STATUS_CANCEL:
      return 'warning';
    default:
      return 'secondary';
  }
};

SubscriberService.PAYMENT_TYPE_STRIPE = 0;
SubscriberService.PAYMENT_TYPE_MANUAL = 1;

SubscriberService.getPaymentsTypeList = t => ({
  [SubscriberService.PAYMENT_TYPE_STRIPE]: 'Stripe',
  [SubscriberService.PAYMENT_TYPE_MANUAL]: t('Manual'),
});

SubscriberService.getPaymentTypesOptions = t => SubscriberService
  .prepareOptionsFromSimpleObject(SubscriberService.getPaymentsTypeList(t));

SubscriberService.getPaymentTypesTitle = (status, t) => {
  const label = SubscriberService.getPaymentsTypeList(t)[status];
  return label || '-';
};

SubscriberService.PAYMENT_PERIOD_TYPE_YEAR = 'year';
SubscriberService.PAYMENT_PERIOD_TYPE_MONTH = 'month';

SubscriberService.getPaymentsPeriodTypeList = t => ({
  [SubscriberService.PAYMENT_PERIOD_TYPE_MONTH]: t('Month'),
  [SubscriberService.PAYMENT_PERIOD_TYPE_YEAR]: t('Year'),
});

SubscriberService.getPaymentPeriodTypesOptions = t => SubscriberService
  .prepareOptionsFromSimpleObject(SubscriberService.getPaymentsPeriodTypeList(t));

SubscriberService.getPaymentPeriodTypesTitle = (status, t) => {
  const label = SubscriberService.getPaymentsPeriodTypeList(t)[status];
  return label || '-';
};

SubscriberService.getUrl = (item) => {
  if (item.domain && item.status_domain === 4) {
    return `https://${item.domain}`;
  }
  return `https://${item.name}.${api.baseDomain}`;
};

export default SubscriberService;



// WEBPACK FOOTER //
// ./src/services/subscriber.service.js